const options = {
  5: "bg-red-100/5",
  10: "bg-red-100/10",
  25: "bg-red-100/25",
  50: "bg-red-100/50",
  75: "bg-red-100/75",
  90: "bg-red-100/90",
  100: "bg-red-100",
};

const from = {
  5: "from-red-100/5",
  10: "from-red-100/10",
  25: "from-red-100/25",
  50: "from-red-100/50",
  75: "from-red-100/75",
  90: "from-red-100/90",
  100: "from-red-100",
};

export default function getBackgroundRed100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
